<template>
  <div class="duration-field">
    <slot />
    <div class="duration-field__controls" v-if="isDisabled !== 0">
      <div
        class="duration-field__control"
        tabindex="0"
        @keyup.enter="$emit('plus')"
        @click="$emit('plus')"
      >
        <icon width="16" height="16" name="duration-plus" />
      </div>
      <div
        class="duration-field__control"
        tabindex="0"
        @keyup.enter="$emit('minus')"
        @click="$emit('minus')"
      >
        <icon width="16" height="16" name="duration-minus" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DurationField',
  props: {
    isDisabled: {
      type: [Number, Boolean],
      default: false
    },
    inputValue: {
      default: 0
    }
  },
  methods: {
    input(e) {
      console.log(e.target.value);
      this.$emit('input', e.target.value);
    }
  }
};
</script>
